import { IonAlert } from "@ionic/react";
import { AllieAlertProps } from "./Alert.types";

export const AllieAlert: React.FC<AllieAlertProps> = ({ isOpen, ...props }) => (
  <IonAlert isOpen={isOpen} {...props} />
);
